import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 440,
  maxHeight: 800,
  bgcolor: "background.paper",
  border: "2px solid #E2E8F0",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
};

function DeleteConfirmationModal(props) {
  const getDescription = () => {
    if (props.permanent) {
      if (props.itemType === "folder") {
        return `This will permanently delete the folder "${props.itemName}" and all of its contents. This action cannot be undone.`;
      }
      return `This will permanently delete "${props.itemName}". This action cannot be undone.`;
    }
    if (props.itemType === "folder") {
      if (props.hasContents) {
        return `Are you sure you want to delete the folder "${props.itemName}" and all of its contents? You can restore it from the trash.`;
      }
      return `Are you sure you want to delete the folder "${props.itemName}"?`;
    }
    return `Are you sure you want to delete "${props.itemName}"?`;
  };

  return (
    <Modal
      open={props.open}
      onClose={() => props.handleClose()}
      aria-labelledby="delete-modal-title"
      aria-describedby="delete-modal-description"
    >
      <Box sx={style}>
        <div
          className="absolute right-2 top-2 text-gray-500 cursor-pointer"
          onClick={() => props.handleClose()}
        >
          <CloseIcon />
        </div>
        <div>
          <div className="flex items-center space-x-2">
            <div className="text-rose-800">
              <WarningIcon style={{ marginBottom: "1px" }} />
            </div>
            <h3 className="text-2xl text-slate-900">Are you sure?</h3>
          </div>
          <p className="text-slate-500 text-sm mt-4">{getDescription()}</p>
          <div className="w-full flex justify-end mt-8">
            <div className="flex space-x-3">
              <div
                className="px-8 py-2 bg-rose-200 hover:bg-rose-300 text-rose-800 rounded-lg text-base w-fit cursor-pointer"
                onClick={() => props.handleConfirm()}
              >
                Delete
              </div>
              <div
                className="px-8 py-2 bg-white border border-violet-700 text-violet-700 hover:bg-slate-100 rounded-lg text-base w-fit cursor-pointer"
                onClick={() => props.handleClose()}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default DeleteConfirmationModal;
